import { defineAsyncComponent } from 'vue'
export default {
  "nav-admin": defineAsyncComponent(() => import("/work/release/fe-oj-ninja/layouts/NavAdmin.vue").then(m => m.default || m)),
  "nav-oj": defineAsyncComponent(() => import("/work/release/fe-oj-ninja/layouts/NavOj.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/work/release/fe-oj-ninja/layouts/default.vue").then(m => m.default || m))
}